import React from "react";
import { usePlatformAdmin } from "context/PlatformAdminContext";

const PlatformTenantBar = () => {
  const { tenantContext, exitTenant } = usePlatformAdmin();

  if (!tenantContext?.spName) {
    return null;
  }

  return (
    <div
      className="border-b border-indigo-200 bg-indigo-50 px-4 py-2 sm:px-6 lg:px-8"
      role="status"
      aria-live="polite"
    >
      <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-3">
          <span
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-indigo-200 text-xs font-bold uppercase tracking-wide text-indigo-900"
            aria-hidden="true"
          >
            Tn
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-indigo-950">
              Tenant context ·{" "}
              <span className="text-indigo-900">{tenantContext.spName}</span>
            </p>
            <p className="mt-0.5 text-xs text-indigo-800/90">
              Platform admin view — you are not impersonating a user.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={exitTenant}
          className="shrink-0 rounded-lg border border-indigo-300 bg-white px-3 py-1.5 text-sm font-medium text-indigo-800 transition-colors hover:bg-indigo-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          Return to platform
        </button>
      </div>
    </div>
  );
};

export default PlatformTenantBar;
